import { Controller } from "@hotwired/stimulus"

const SCALAR_SCRIPT_ID = "scalar-api-reference-script"
const SCALAR_SCRIPT_SRC = "https://cdn.jsdelivr.net/npm/@scalar/api-reference@1.49.8"
const SCALAR_CONFIGURATION = {
  agent: {
    disabled: true,
  },
  defaultHttpClient: {
    clientKey: "curl",
    targetKey: "shell",
  },
  forceDarkModeState: "light",
  hiddenClients: {
    c: true,
    clojure: true,
    csharp: true,
    go: true,
    http: true,
    java: true,
    js: false,
    kotlin: true,
    objc: true,
    ocaml: true,
    php: true,
    powershell: true,
    python: false,
    r: true,
    ruby: false,
    rust: true,
    shell: ["httpie", "wget"],
    swift: true,
  },
  hideClientButton: true,
  hideDarkModeToggle: true,
  hideModels: true,
  hideTestRequestButton: true,
  layout: "modern",
  mcp: {
    disabled: true,
  },
  showDeveloperTools: "never",
  showSidebar: true,
  withDefaultFonts: false,
}

export default class extends Controller {
  static values = {
    url: String,
  }

  async connect() {
    if (!this.urlValue) return

    await this.loadScalar()
    this.renderReference()
  }

  disconnect() {
    this.instance?.destroy?.()
    this.instance = null
    this.element.innerHTML = ""
  }

  loadScalar() {
    if (window.Scalar?.createApiReference) return Promise.resolve()

    if (window.__scalarApiReferenceLoader) return window.__scalarApiReferenceLoader

    window.__scalarApiReferenceLoader = new Promise((resolve, reject) => {
      const existingScript = document.getElementById(SCALAR_SCRIPT_ID)

      if (existingScript) {
        existingScript.addEventListener("load", resolve, { once: true })
        existingScript.addEventListener("error", reject, { once: true })
        return
      }

      const script = document.createElement("script")
      script.id = SCALAR_SCRIPT_ID
      script.src = SCALAR_SCRIPT_SRC
      script.async = true
      script.onload = resolve
      script.onerror = reject
      document.head.appendChild(script)
    })

    return window.__scalarApiReferenceLoader
  }

  renderReference() {
    if (!this.element.id) {
      this.element.id = "api-reference-root"
    }

    this.instance?.destroy?.()
    this.element.innerHTML = ""
    this.instance = window.Scalar.createApiReference(`#${this.element.id}`, {
      ...SCALAR_CONFIGURATION,
      url: this.urlValue,
    })
  }
}
